export const classes = (...args) => {
  const arr = [];
  args.forEach(arg => (arg ? arr.push(arg) : null));
  return arr.join(' ');
};

export const parseActions = (actions, fallback = []) => {
  let array;

  if (typeof actions === 'string') {
    array = actions.trim().replace(/\s+/g, ' ').split(' ');
  } else if (Array.isArray(actions)) {
    array = actions;
  } else {
    array = fallback;
  }

  const obj = {};
  array.forEach(it => (obj[it] = true));

  return obj;
};
